import React, {useState, useEffect} from "react"
import styled from "styled-components"
import BtnCompo from "../../../SubComponents/Btn"
import SoloPay from "../Family/Pay/SoloPay"
import DuoPay from "./Pay/DuoPay"
const Styled ={
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    BtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,
    Inputs:styled.input`
        width:75%;
        height:40px;
        border-radius: 20px;
        border:1px solid #eee;
        padding:10px;
        font-size:20px;
    `,
    NextBtn:styled.div`
        width:50px;
        height:40px;
        padding:10px;
        border-radius: 10px;
        background-color: gold;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: row;
        :hover{
            opacity:50%;
            cursor:pointer;
        }
    `,
}
interface PropsType {
    Points : number;
    setPoints : any;
    Solo_Duo: number;
    setSolo_Duo: any;
    Economi_Solo?:boolean;
}
const FamilyNum=(props:PropsType)=>{
    const setPoints = props.setPoints
    const Points = props.Points
    const Solo_Duo = props.Solo_Duo
    const setSolo_Duo = props.setSolo_Duo
    const Economi_Solo = props.Economi_Solo //true면 외벌이 
    const [Page, setPage] = useState<boolean>(false)
    const [Babies, setBabies] = useState<any>(0)
    const [Family, setFamily] = useState<number>(0)
    const [description, setDescription] = useState<string>("")
    useEffect(()=>{
        if(Babies === 0){
            setDescription("없어요")
        }else if(Babies === NaN){
            alert("제대로 입력해주세요")
        }else{
            setDescription(Babies + "명")
        }
    })
    
    const AddFamily =()=>{
        const Baby = Number(Babies);
        if(Baby >= 3){
            setPoints(Points + 3)
        }else if(Baby === 3){
            setPoints(Points + 3)
        }else if (Baby === 2){
            setPoints(Points + 2)
        }else if (Baby === 1){
            setPoints(Points + 1)
        }else {
            setPoints(Points)
        }
        setFamily(Solo_Duo + Baby)
        setPage(true)
    }
    
    if(Page === false){
        return(
            <Styled.Wrap>
                <Styled.LittleTitleFont>미성년 자녀는 몇명이 있나요?<br/>(숫자만 적어주세요)</Styled.LittleTitleFont>
                <Styled.Fonts>{description}</Styled.Fonts>
                <Styled.BtnWrap>
                    <Styled.Inputs onChange={(event)=>{setBabies(event.target.value)}}/>
                    <Styled.NextBtn onClick={AddFamily}>
                        <Styled.Fonts>완료</Styled.Fonts>
                    </Styled.NextBtn>
                </Styled.BtnWrap>
            </Styled.Wrap>
        )
    }else{
        if(Solo_Duo === 1){
            //혼자 벌때 소득 80%
            //57889536
            return(
                <SoloPay 
                    setFamily={setFamily}
                    Family={Family}
                    setPoints={setPoints}
                    Points={Points}
                />
            )
        }else{
            //Solo_Duo가 2일때
            // 맞벌이 100%
            if(Economi_Solo === false){
                //맞벌이
                return(
                    <DuoPay
                        setFamily={setFamily}
                        Family={Family}
                        setPoints={setPoints}
                        Points={Points}
                    />
                )
            }else{
                return(
                    //결혼은 했지만 외벌이
                    <SoloPay 
                        setFamily={setFamily}
                        Family={Family}
                        setPoints={setPoints}
                        Points={Points}
                    />
                )
            }
        }
    }
}

export default FamilyNum